import React from 'react';

const SpeakerTopics = () => {
  const trainingData = [
    {
      title: 'Audit Your Life, Business & Income (Entrepreneurs, Business Owners, CEO\'s, Executive, Professional, Students, any Go getters)',
      topic: 'Break Through Plateaus & Build a Million-Dollar Gameplan',
      outcomes: [
        'Identify income leaks & business gaps',
        'Create a personal business roadmap',
        'Learn action-first mindset to fix, grow & scale'
      ]
    },
    {
      title: 'Launch Code for Entrepreneurs & Startup & Business Owners.',
      topic: 'How to Launch a Profitable Business or Offer in 30 Days',
      outcomes: [
        'Identify a validated business idea with market demand',
        'Build & launch a minimum viable offer (MVO) fast',
        'Craft a 30-day marketing + sales launch plan',
        'Learn the 5-part offer framework that sells',
        'Avoid overwhelm by using a focused launch checklist'
      ]
    },
    {
      title: 'Growth Code for Entrepreneurs & Business Owners.',
      topic: 'Sales, Marketing & Branding for 10x Business Growth',
      outcomes: [
        'Master sales frameworks that convert',
        'Build irresistible offers and brand authority',
        'Scale with systems, not burnout'
      ]
    },
    {
      title: 'Scale Code for Entrepreneurs & Business Owners',
      topic: 'Systems, Teams & Automation to Build a Real Company',
      outcomes: [
        'Create freedom with operations, not exhaustion',
        'Delegate without fear',
        'Install repeatable systems to scale without you'
      ]
    },
    {
      title: 'Wealth Code for Entrepreneurs, Business owners, CEOs, Executives, Professionals, Students',
      topic: 'How to Build, Multiply & Protect Income Streams',
      outcomes: [
        'Learn the 3-stage income growth model',
        'Discover practical income stacking strategies',
        'Understand how to shift from income to assets'
      ]
    },
    {
      title: 'Sales Code for Entrepreneurs, Business owners, Professionals.',
      topic: 'Master Sales Psychology, Offers & Closings Without Being Pushy',
      outcomes: [
        'Understand buyer psychology & decision triggers',
        'Create high-converting sales scripts & objection busters',
        'Master storytelling and offer positioning',
        'Learn how to close high-ticket deals with confidence',
        'Build a repeatable sales system that scales'
      ]
    },
    {
      title: 'Digital Code for Entrepreneurs, Wannapreneurs, Business Owners',
      topic: 'From Offline Hustle to Scalable Online Income',
      outcomes: [
        'Launch your online business in 7 steps',
        'Build audience, authority, and automation',
        'Turn skills into digital cashflow.'
      ]
    },
    {
      title: 'Investment Code for Entrepreneurs, Business Owners, Professionals',
      topic: 'Halal & Smart Ways to Multiply Money Without Stress',
      outcomes: [
        'Learn low-risk, high-principle investment models',
        'Understand profit-sharing models vs. interest-based',
        'Build generational income the right way'
      ]
    },
    {
      title: 'Career Code for Students, Freshers & Unemployed Individuals.',
      topic: 'Build a 6-Figure Career from Passion, Not Pressure',
      outcomes: [
        'Discover your core skill and turn it into income',
        'Build a career roadmap with clarity',
        'Position yourself in the premium job or freelance market'
      ]
    },
  ];

  const boxStyle = {
    border: '1px solid violet',
    backgroundColor: 'rgba(238, 130, 238, 0.1)', // light violet
    borderRadius: '8px',
    padding: '20px',
    height: '100%',
  };

  return (
    <div className="container my-5">
      <div className="row">
        {trainingData.map((item, index) => (
          <div key={index} className="col-md-4 mb-4">
            <div style={boxStyle}>
              <h5 className="fw-bold text-center">{item.title}</h5>
              <p className="fw-semibold">Topic: {item.topic}</p>
              <p className="mb-1 fw-semibold">Outcomes:</p>
              <ul className="mb-0">
                {item.outcomes.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpeakerTopics;
